import React from "react";
import { Check } from "lucide-react";
import { painPoints } from "../mock";
import Reveal from "./Reveal";

export default function PainPoints() {
  return (
    <section className="relative border-t border-white/[0.06] py-24">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <p className="mb-5 text-[13px] font-semibold uppercase tracking-[0.2em] text-violet-400">
            {painPoints.eyebrow}
          </p>
          <h2 className="max-w-3xl font-display text-[38px] font-bold leading-[1.08] text-white sm:text-[52px]">
            {painPoints.headingBefore}
            <span className="text-gradient-violet">{painPoints.headingAccent}</span>
            {painPoints.headingAfter}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-4 sm:grid-cols-2">
          {painPoints.items.map((item, i) => (
            <Reveal key={i} delay={i * 60}>
              <div className="surface-card flex items-center gap-4 rounded-2xl px-6 py-5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-violet-300 to-violet-400 text-[#1a1626] shadow-[0_0_16px_rgba(167,139,250,0.4)]">
                  <Check className="h-[18px] w-[18px]" strokeWidth={2.5} />
                </span>
                <span className="text-[16px] text-white/85">{item}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
